"use strict";

import $ from "jquery";

class ToggleCaption
{
    constructor(toggle) {
        if (! $(toggle).length) {
            return;
        }

        const $toggle = $(toggle);

        if ($toggle) {
            const $target = $('#' + $toggle.data('toggle-caption'));

            if ($target) {
                $toggle.on('click', function(event) {
                    event.preventDefault();
                    $toggle.toggleClass('open');
                    $target.toggle();
                });
            }
        }
    }
}

export default ToggleCaption;
